<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/inventario_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Maximiza el uso de tu <br />
            inventario
          </h2>
          <p class="my-3">
            ContaFácil permite el control y <br class="not-mobile" />
            monitoreo del inventario de tus puntos<br class="not-mobile" />
            de venta de la forma más simple y<br class="not-mobile" />
            sencilla.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--right no-padding--left">
      <div class="columns is-desktop section__video section__video--column">
        <h3 class="color-primary">
          Administra tus productos en un solo lugar
        </h3>
        <div class="inventario">
          <img
            src="../assets/images/inventario_1.png"
            alt=""
            class="img--center"
          />
        </div>
        <!-- <h3 class="color-primary is-hidden-desktop">
          Administra tus productos en un solo lugar
        </h3> -->
        <p>
          ContaFácil permite administrar productos en cada punto de venta.
          <br class="not-mobile" />
          Envío de alertas de stock por agotarse, fuera de stock y lotes con
          <br class="not-mobile" />fecha de vencimiento expirada.
        </p>
        <a
          rel="noopenner noreferer"
          class="button is-rounded bg-primary"
          href="https://app.contafacil.pe/#!/registro"
          @click="emitGlobalTriggerGtag('prueba_gratis')"
          >Prueba Gratis</a
        >
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="inventario column">
          <img src="../assets/images/inventario_2.png" alt />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Monitorea la cantidad de stock <br />disponible en cada punto de
              venta
            </h3>
            <p>
              No pierdas ventas por no contar<br class="not-mobile" />
              con stock disponible. Ten<br class="not-mobile" />
              seguimiento de la cantidad de <br class="not-mobile" />producto en
              tus almacenes.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-mr-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--right mar-top">
        <div
          class="inventario inventario-especial column column-50 column-offset-10"
        >
          <img class="mal" src="../assets/images/inventario_3.svg" alt />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Organiza tus compras de inventario<br class="not-mobile" />
              y productos por consignación
            </h3>
            <p>
              Emite órdenes, registra compras y<br class="not-mobile" />
              guías de consignación. ContaFácil<br class="not-mobile" />
              permite administrar el ingreso de<br class="not-mobile" />
              inventario y monitorear las cuentas<br class="not-mobile" />
              por pagar a tus proveedores.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-ml-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="inventario column">
          <img src="../assets/images/inventario_4.png" alt />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Manten visibilidad de los<br />
              movimientos de tu inventario
            </h3>
            <p>
              Monitorea cada movimiento de<br class="not-mobile" />
              inventario. Genera anulaciones y<br class="not-mobile" />
              correcciones. No pierdas tracking de<br class="not-mobile" />
              tus productos.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-mr-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";
export default {
  name: "Inventario",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/flHvfRKtKB0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/inventario_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    // height: 75%;
    width: 100%;
    margin-top: auto;
    // padding: 3rem 1rem;
    p {
      width: fit-content;
    }
  }
  @include tablet() {
    background-image: none;
    height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;
  }
  @media (min-width: 1024px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/inventario.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    background-image: url("../assets/images/banners/inventario.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    height: calc(100vh - 120px);
    background-image: url("../assets/images/banners/inventario.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 1230px;
  }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  // .button {
  //   font-size: 16px;
  //   font-weight: 500;
  // }
  h2 {
    font-weight: bold;
    font-size: 1.2rem;
  }
  &__video {
    width: 100%;
    margin: 1rem 0px;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    // min-height: 450px;
    // padding: 2rem;
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        width: 90%;
        letter-spacing: 0.025em;
        font-size: 16px;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          // max-width: 200px;
          font-size: 1.2rem;
          margin: 1rem auto;
        }
      }
      @media (min-width: 1024px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.2rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          max-width: none;
          margin-top: 1em;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1800px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          max-width: none;
          font-size: 1.2rem;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .inventario {
      padding: 0px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: stretch;
      &-especial {
        order: 1;
      }
      .img--center {
        width: 90%;
        max-width: 500px;
        margin: 1rem auto;
      }
      img {
        max-width: 500px;
        width: 100%;
        height: auto;
      }
      @include tablet() {
        // .mal {
        //   max-width: 400px;
        // }
        .img--center {
          width: 85%;
          max-width: none;
          margin: 1rem auto;
        }
        img {
          max-width: none;
          width: 100%;
          height: auto;
        }
      }
      @include laptop {
        margin: 2em auto;
        .img--center {
          width: 100%;
          max-width: 700px;
          margin: 0px auto;
        }
        img {
          width: 100%;
          max-width: none;
        }
      }
      @include desktop {
        .img--center {
          width: 100%;
          max-width: 900px;
          margin: 0px auto;
        }
        img {
          width: 100%;
          max-width: none;
        }
      }
      @include desktop-medium {
        .img--center {
          width: 100%;
          max-width: 1000px;
          margin: 0px auto;
        }
        img {
          width: 100%;
          max-width: none;
        }
      }
      @include desktop-large {
        .img--center {
          width: 60%;
          max-width: 1200px;
          margin: 0px auto;
        }
        img {
          width: 100%;
          max-width: none;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 1rem;
      width: 100%;
      h3 {
        letter-spacing: 0.018em;
        font-size: 1.2rem;
        font-weight: bold;
      }
      p {
        font-size: 1rem;
      }
      .button {
        margin: 1rem auto;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    &--column {
      width: 100%;
      margin: 0 auto;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: center;
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: bold;
        margin: 2em auto;
        width: 90%;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.025em;
        font-weight: 400;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      .video__player {
        width: 100%;
        height: 500px;
      }
      @include tablet() {
        width: 100%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
        }
        .button {
          // max-width: 200px;
          font-size: 1.2rem;
          // margin: 1rem auto;
        }
      }
      @include desktop() {
        width: 100%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.4rem;
          font-weight: bold;
        }
        p {
          font-size: 1.4rem;
          letter-spacing: 0.025em;
        }
        .button {
          max-width: 200px;
          // margin: 1rem auto;
        }
      }
      @include desktop-medium() {
        width: 100%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
        }
        .button {
          max-width: none;
          width: fit-content;
          // margin: 1rem auto;
          font-size: 1.8rem;
        }
      }
      @include desktop-large() {
        width: 100%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.025em;
        }
        .button {
          max-width: none;
          width: fit-content;
          // margin: 1rem auto;
          font-size: 1.2rem;
        }
      }
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
</style>
